// Utilities to normalize classification tags between UI labels and API-safe values
// Backend validates tags with only word characters (A-Za-z0-9_), so spaces/punctuation must be removed

// Convert a human-friendly label (e.g., "The Arts") to an API-safe tag (e.g., "The_Arts")
export function toApiTag(label) {
  if (!label || typeof label !== 'string') return label;
  const trimmed = label.trim();
  // Replace spaces with underscores, drop other non-word chars; keep underscores and alphanumerics
  const underscored = trimmed.replace(/\s+/g, '_');
  const cleaned = underscored.replace(/[^A-Za-z0-9_]/g, '');
  // Collapse multiple underscores
  return cleaned.replace(/_+/g, '_');
}

// Convert an API tag back to a display label (e.g., "The_Arts" -> "The Arts")
export function toDisplayLabel(tag) {
  if (!tag || typeof tag !== 'string') return tag;
  return tag.replace(/_/g, ' ');
}
